import { Button, Modal } from '@shared/widgets';
import SuccessIcon from '@assets/images/auth/auth_success_ico.svg';

interface ISuccessfullyBlockUnblockModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const SuccessfullyBlockUnblockModal = (props: ISuccessfullyBlockUnblockModalProps) => {
  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose}>
      <SuccessIcon className='mx-auto mb-4 hidden max-md:block' />
      <h2 className='mb-12 text-center font-[Prata] text-[28px] font-medium text-[#0f0f11] max-md:mb-6 max-md:text-lg'>Request Successful</h2>
      <p className='mb-9 font-medium max-md:rounded-[10px] max-md:bg-[#d7c29a10] max-md:p-[10px] max-md:font-[Prata] max-md:text-lg'>
        Your changes have been successfully implemented. If you have any further queries, please contact customer service for assistance. 24-hour
        phone support: +44-203-151-7000 / +800-800-00-700
      </p>
      <Button className='mx-auto w-[159px] max-md:w-full' onClick={props.onClose}>
        Ok
      </Button>
    </Modal>
  );
};
